export enum CoughAnalysisSetTypeEnum {
	Analysis = "CAS_ANALYSIS",
	DeviceEvents = "CAS_DEVICE_EVENTS",
	QualityCheck = "CAS_QC",
	ProjectQualityAssurance = "CAS_PROJECT_QA",
	WeeklyQualityAssurance = "CAS_WEEKLY_QA",
	MonitoringQualityAssurance = "CAS_MONITORING_QA",
	DifficultCougherQualityAssurance = "CAS_DIFFICULT_COUGHER_QA",
    AuditQualityAssurance = "CAS_AUDIT_QA",
	CoughBouts = "CAS_COUGH_BOUTS",
    AbacasCoughCount = "CAS_ABACAS_ANALYSIS",
    Adjudication = "CAS_ADJUDICATION"
}
